import { useEffect, useState } from 'preact/hooks'
import { useView } from '../app/use-view.ts'
import { ShopStateContext } from '../os/apps/shop/shop-state.ts'
import { ComputerModal } from './computer-modal.tsx'
import { OsStatesContext, createOsStates } from './os-states.ts'
import { PhoneDevice } from './phone-device.tsx'

/**
 * The devices that show the OS, in the HUD layer: the phone and the computer. Their OS
 * states are made once per level session, so a reload starts them clean. Checkout answers
 * are settled here, so an order placed just before its app closed still clears its basket.
 */
export function Devices() {
  const level = useView((view) => view.level)
  const [states, setStates] = useState(createOsStates)
  const [statesLevel, setStatesLevel] = useState(level)
  if (level !== statesLevel) {
    setStatesLevel(level)
    setStates(createOsStates())
  }
  const checkout = useView((view) => view.shops.checkout)
  useEffect(() => {
    if (checkout) states.shop.settle(checkout)
  }, [states, checkout])

  return (
    <OsStatesContext.Provider value={states}>
      <ShopStateContext.Provider value={states.shop}>
        <PhoneDevice />
        <ComputerModal />
      </ShopStateContext.Provider>
    </OsStatesContext.Provider>
  )
}
